import { withState } from 'recompose';

export default withState(
  'removeAccountHolderInfo',
  'updateRemoveAccountHolderInfo',
  {}
);
